import { RouteComponentProps } from "react-router-dom";
import { InsuredData } from "../../containers/hirings/new-hiring/salud-pymes/salud-pymes-insured/salud-pymes-insured-types";

export enum Steps {
  DatosTomador = 1,
  DatosAsegurados = 2,
  Garantias = 3,
  DocumentacionRequerida = 4,
  ProteccionDatos = 5,
  Prima = 6,
  Cuestionarios = 7,
  MetodosPago = 8,
  DetallePrevioContratacion = 9,
}

export interface SaludPymesHireMenuProps extends RouteComponentProps<any> {
  initialCurrentStep: Steps;
  initialInsureds: InsuredData[];
  codMediador: string;
  selectedMediator?: string;
  insuredSaved?: boolean;
  disableSubButtons?: boolean;
  currentNumInsured?: number;
  isSignedDocument?: boolean;
  isHired?: boolean;
  disableSignButton?: boolean;
  physicalSignature?: boolean;
  policy: any;
  coverages: any;
  countries: any;
  taker: any;
  previousOnNavigation?: () => boolean;
  insuredOnAdd?: (insuredSaved: any) => Promise<void>;
  insuredOnRemove?: (index: number) => void;
  insuredOnEdit?: (index: number) => void;
  insuredOnSave?: () => void;
  questionnaireOnEdit?: (index: number) => void;
  questionnaireOnSave?: () => void;
  resumeOnHiring?: () => void;
  downloadPrecontractualDocument?: () => void;
  sendMailPrecontractualDocument?: (showModal?: boolean) => void;
  signPrecontractualDocument?: () => void;
  payHiring?: () => void;
  setLoading?: () => void;
}

export interface SaludPymesHireMenuState {
  currentStep: Steps;
  insureds: InsuredData[];
  showInsuredsOnDatosAsegurados: boolean;
  showInsuredsOnCuestionarios: boolean;
  mediador: string;
  modal: {
    img: string;
    className: string;
    mainTitle: string;
    mainText: string;
  };
}
